import { render, staticRenderFns } from "./App.vue?vue&type=template&id=60a9fdcf&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=60a9fdcf&lang=less&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9fdcf",
  null
  
)

export default component.exports